import { createFileRoute, redirect } from '@tanstack/react-router';

import { BonusAllocator } from '../../modules/SpiffToolLogs/allocator/BonusAllocator';
import { managerCheck } from '../../tools/permissionChecks';

export const Route = createFileRoute('/spiffLog/allocator')({
  component: RouteComponent,
  loader(ctx) {
    if (!managerCheck(ctx.context.authContext.user)) {
      throw redirect({ to: '/spiffLog' });
    }
  },
  head() {
    return {
      meta: [{ title: 'Bonus Allocator 9000' }],
    };
  },
});

function RouteComponent() {
  return <BonusAllocator />;
}
